<!--
  Props:

  Optional:
  1) disable - Disable the button

 -->
<template lang="html">
  <button class="pl-button default truncate-text" :disabled="disabled">
    <slot></slot>
  </button>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
  };
</script>

<style scoped lang="stylus">

  /****** Import Global Stylus ******/

  @import '~app/global-stylus'

  /****** Defaults ******/

  .default
    color: pl-slate
    background-color: transparent
    position: relative
    overflow: hidden
    font-family: inherit
    line-height: 36px
    white-space: nowrap
    padding: 0px 12px
    margin: 6px 8px
    cursor: pointer
    border: 0
    border-radius: 2px
    min-height: 36px
    min-width: 88px
    font-size: 14px
    &.feedback-theme
      background-color: #5FA95C
      color : white
      height: 15px;
      font-size: 12px
      font-weight: bold
      &&:hover
        background-color: #04540f

  .three-dots
    margin-left: 0px;

  .default:hover
    background-color: rgba(0,0,0,0.04)

  .pl-rounded
    border-radius: 30px !important

  button[disabled]
    color: #ccc !important
    background-color: transparent !important
    box-shadow: none !important
    pointer-events: none;

  button[disabled]:hover
    background-color: rgba(0,0,0,0) !important
    cursor: default !important

  /****** Button Colours ******/

  .pl-primary
    set-background-color(pl-primary)
    color: white
    &&:hover
      set-darken-background(pl-primary)

  .pl-primary-reverse
    set-background-color(white)
    color: pl-primary
    &&:hover
      set-darken-background(white)

  .pl-primary-font
    color: pl-primary

  .pl-secondary
    set-background-color(pl-secondary)
    color: white
    &&:hover
      set-darken-background(pl-secondary)

  .pl-secondary-font
    color: pl-secondary

  .pl-ruby
    set-background-color(pl-ruby)
    color: white
    &&:hover
      set-darken-background(pl-ruby)

  .pl-ruby-font
    color: pl-ruby

  .pl-slate
    set-background-color(pl-slate)
    color: white
    &&:hover
      set-darken-background(pl-slate)

  .pl-slate-font
    color: pl-slate

  .pl-fog
    set-background-color(pl-fog)
    &&:hover
      set-darken-background(pl-fog)

  .pl-fog-font
    color: pl-fog

  .pl-charcoal
    set-background-color(pl-charcoal)
    color: white
    &&:hover
      set-darken-background(pl-charcoal)

  .pl-charcoal-font
    color: pl-charcoal

  .pl-white
    set-background-color(white)
    color: pl-charcoal
    &&:hover
      set-darken-background(white)

  .pl-white-font
    color: white;

  .pl-red
    set-background-color(pl-light-red)
    color: white
    &&:hover
      set-darken-background(pl-light-red)

  .pl-gold
    set-background-color(gold)
    color: pl-charcoal
    &&:hover
      set-darken-background(gold)

  .pl-gold-font
    color: #FFCC33;

  .pl-icon
    display: inline-flex
    justify-content: center
    align-items: center
    height: 36px
    width: 36px
    min-width: 36px
    border-radius: 50%
    padding: 0px
    img, i
      max-width: 18px;

  .pl-small
    font-size: 12px
    line-height: 24px
    min-height: 24px
    min-width: 24px

  .pl-small-rounded
    font-size: 12px
    line-height: 20px
    min-height: 20px
    border-radius: 50px
    width: 60px
    min-width: 60px

  .pl-small.pl-icon
    min-height: 24px
    min-width: 24px
    max-width: 24px
    max-height: 24px
    padding: 0px
    i
      font-size: 12px

  .pl-no-margin
    margin: 0px;

  .pl-no-padding
    padding: 0px;

  .pl-border
    border: 2px solid;

  .pl-border-fog
    border: 2px solid pl-fog;

  .pl-caption-font
    font-size: 12px;

  .nav-rt-button
    min-width:auto;
    border-radius: 5px;
    height: 36px
    font-weight:700
</style>



// WEBPACK FOOTER //
// plButton.vue?05a0fc8a